import { myIcons } from "@/utils/icons";
import "@/css/TopArea.css"
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import { useState, useEffect, useRef } from "react";
import { t } from "i18next";


type LabeledIconPropsI = {
    icon: string;
    label: string;
    value: number;
};

const LabeledIcon = ({ icon, label, value }: LabeledIconPropsI) => {
    return (
        <div className="labeled-icon" style={{ display: "flex", flexDirection: 'column', alignItems: "center", gap: "10px" }}>
            <ProgressBar value={value} />
            <motion.div
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <div
                    className="boxed-icon"
                    style={{
                        display: 'flex',
                        borderRadius: '5px',
                        border: '1px solid #000000',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                    }}>
                    <img src={icon} alt=""
                        style={{
                            margin: '5px',
                        }}
                    />
                </div>
            </motion.div>
            <p style={{
                whiteSpace: 'nowrap'
            }}>{label}</p>
        </div>
    );
};

export const TopArea = () => {
    const animasyonGif = "../assets/pictures/circuit.gif";
    return (
        <div style={{
            backgroundColor: 'var(--color-bg-secondary)',
            color: 'var(--color-text)',
            borderRadius: '10px',
            padding: '20px',
            backgroundImage: `url(${animasyonGif})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right bottom',
            backgroundSize: 'contain',
            backgroundBlendMode: 'multiply',
        }}
        >
            <div className="top-area-top"
                style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px'
                    }}
                >
                    <h2
                        style={{
                            color: '#3f51b5'
                        }}
                    >yasinyildiz.dev
                        <TextChanger />
                    </h2>
                    <p
                        style={{
                            maxWidth: '500px',
                        }}
                    >
                        {t("my-desc")}
                    </p>
                    <div className="socials"
                        style={{
                            display: 'flex',
                            gap: '10px'
                        }}
                    >
                        <a href="https://github.com/yasinyildizdev" target="_blank" rel="noopener noreferrer">
                            <img src={myIcons.socials.github} alt="GitHub" />
                        </a>
                        <a href="https://www.linkedin.com/in/yasin-yildiz-218b34218/" target="_blank" rel="noopener noreferrer">
                            <img src={myIcons.socials.linkedin} alt="LinkedIn" />
                        </a>
                        <a href="https://google.com" target="_blank" rel="noopener noreferrer">
                            <img src={myIcons.socials.google} alt="Google" />
                        </a>
                        <a href="https://instagram.com/08yasins" target="_blank" rel="noopener noreferrer">
                            <img src={myIcons.socials.instagram} alt="Instagram" />
                        </a>
                    </div>
                    <p>yasinyildiz479@gmail.com</p>
                </div>
                <PhotoSlider />
            </div>


            <div style={{ height: "2px", backgroundColor: "grey", margin: "16px 0" }}></div>

            <div className="show-skills"
            >
                <LabeledIcon icon={myIcons.programs.tiaportal} label="Tia Portal" value={90} />
                <LabeledIcon icon={myIcons.programs.altium} label="Altium" value={70} />
                <LabeledIcon icon={myIcons.programs.eplan} label="Eplan" value={60} />
                <LabeledIcon icon={myIcons.programs.solidworks} label="SolidWorks" value={90} />

                <LabeledIcon icon={myIcons.programs.stm32} label="STM32" value={70} />
                <LabeledIcon icon={myIcons.programs.autocad} label="Autocad" value={40} />
                <LabeledIcon icon={myIcons.programs.matlab} label="MATLAB" value={70} />
                <LabeledIcon icon={myIcons.programs.vscode} label="VsCode" value={80} />
            </div>
        </div >
    );
};

const ProgressBar = ({ value }: { value: number }) => {
    return (
        <div style={{ width: "100%", height: "8px", background: "#ddd", borderRadius: "10px", overflow: "hidden" }}>
            <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: `${value}%` }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                style={{
                    height: "100%",
                    backgroundColor: "#3f51b5",
                }}
            />
        </div>
    );
}

const TextChanger = () => {
    const texts = ["elopment", "eloper", "ote"];
    const [displayText, setDisplayText] = useState("");
    const [index, setIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        const current = texts[index];
        let speed = isDeleting ? 50 : 100; // silerken daha hızlı

        const timeout = setTimeout(() => {
            setDisplayText((prev) =>
                isDeleting
                    ? prev.slice(0, -1)
                    : current.slice(0, prev.length + 1)
            );

            // Yazma tamamlandı → silmeye başla
            if (!isDeleting && displayText === current) {
                setTimeout(() => setIsDeleting(true), 1000);
            }
            // Silme tamamlandı → sonraki kelimeye geç
            else if (isDeleting && displayText === "") {
                setIsDeleting(false);
                setIndex((prev) => (prev + 1) % texts.length);
            }
        }, speed);

        return () => clearTimeout(timeout);
    }, [displayText, isDeleting, index, texts]);

    return (
        <motion.span
            style={{
                display: "inline-block",
                marginLeft: "4px",
                color: "#cccdd2ff"
            }}
            animate={{ opacity: [0.8, 1, 0.8] }} // hafif yanıp sönme efekti
            transition={{ duration: 1, repeat: Infinity }}
        >
            {displayText}
        </motion.span>
    );
}


const images = [
    "../assets/pictures/my-profile1.jpg",
    "../assets/pictures/my-profile2.jpg",
    "../assets/pictures/my-profile3.jpg",
];

type Direction = number;

const variants = {
    enter: (direction: Direction) => ({
        x: direction > 0 ? 100 : -100,
        opacity: 0,
        scale: 0.8,
    }),
    center: {
        x: 0,
        opacity: 1,
        scale: 1,
    },
    exit: (direction: Direction) => ({
        x: direction < 0 ? 100 : -100,
        opacity: 0,
        scale: 1.2,
    }),
};

export default function PhotoSlider() {
    const imgRef = useRef<HTMLImageElement>(null);
    const [[index, direction], setIndex] = useState([0, 0]);

    useEffect(() => {
        const rect = imgRef.current!.getBoundingClientRect();
        console.log(rect);
        const timer = setInterval(() => {
            setIndex(([prevIndex]) => {
                const nextIndex = (prevIndex + 1) % images.length;
                return [nextIndex, 1]; // 1 yön sağa doğru
            });
        }, 3500);
        return () => clearInterval(timer);
    }, []);

    return (
        <div
            style={{
                width: 200,
                height: 200,
                position: "relative",
                overflow: "hidden",
                borderRadius: "1000px",
            }}
        >
            <AnimatePresence initial={false} custom={direction} mode="wait">
                <motion.img
                    ref={imgRef}
                    key={images[index]}
                    src={images[index]}
                    custom={direction}
                    variants={variants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    transition={{ duration: 0.8, ease: "easeInOut" }}
                    style={{
                        position: "absolute",
                        width: "200px",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "1000px",
                    }}
                />
            </AnimatePresence>
        </div>
    );
}